import '../scss/style.scss';
import '../js/form.js';

console.log('Parcel is working. Hurray!');